<template>
  <!-- Horizontal items slider component -->
  <div class="w-full slider-container" :class="{ rtl: isRightToLeft }">
    <div
      class="w-full slider flex no-scrollbar sm:overscroll-x-none relative"
      ref="slider"
      @scroll="(e) => onContainerScroll(e)"
    >
    <component :is="wrapperTagType" ref="slotContainer" :class="`${appendedClass} slider-content flex flex-nowrap gap-${gap} pt-${paddingTop}`.trim()">
        <!-- items list being injected by the parent -->
        <slot></slot>
        <!-- Duplicated content for infinite loop -->
        <template v-if="shouldLoop && isMobileView">
          <slot></slot>
          <slot></slot>
          <slot></slot>
          <slot></slot>
        </template>
      </component>
    </div>
    <!-- prev button -->
    <!-- <button
      :aria-label="isRightToLeft ? $t('general.next') : $t('general.previous')"
      v-show="!hideArrows"
      @click="scroll(isRightToLeft ? 1 : -1)"
      class="flex border-0 absolute arrow__el !outline-none top-0 bottom-0 items-center z-[2] py-1.5 px-0 cursor-pointer ltr:left-[3px] ltr:right-auto rtl:right-[0px] rtl:left-auto prev"
    >
      <span
        :class="`${disablePrevArrow ? 'invisible': 'arrow-shadow'} active:scale-[0.90] transition-all duration-150 bg-white border active:border-primary overflow-hidden rounded-full p-1.5 lg:p-2 grid place-content-center`"
      >
        <svg
          class="ltr:rotate-0 rtl:rotate-180 h-[17px] w-[17px] lg:h-[20px] lg:w-[20px]"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <g fill="none">
            <path
              d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z"
            />
            <path
              fill="currentColor"
              d="M3.636 11.293a1 1 0 0 0 0 1.414l5.657 5.657a1 1 0 0 0 1.414-1.414L6.757 13H20a1 1 0 1 0 0-2H6.757l3.95-3.95a1 1 0 0 0-1.414-1.414l-5.657 5.657Z"
            />
          </g>
        </svg>
      </span>
      <span class="sr-only">{{ isRightToLeft ? $t('general.next') : $t('general.previous') }}</span>
    </button> -->
    <!-- next button -->
    <!-- <button
      :aria-label="isRightToLeft ? $t('general.previous') : $t('general.next')"
      v-show="!hideArrows || isLoadingMoreStores"
      @click="scroll(isRightToLeft ? -1 : 1)"
      :class="`${isLoadingMoreStores ? 'loading_more' : 'flex'} arrow__el border-0 absolute top-0  !outline-none bottom-0 items-center z-[2] py-1.5 px-0 cursor-pointer ltr:right-[0px] ltr:left-auto rtl:left-[3px] rtl:right-auto next`.trim()"
    >
      <span
        :class="`${disableNextArrow ? 'invisible': 'arrow-shadow'} active:scale-[0.90] transition-all duration-150 bg-white border active:border-primary overflow-hidden rounded-full p-1.5 lg:p-2 grid place-content-center`"
      >
        <svg v-if="!isLoadingMoreStores"
          class="ltr:rotate-180 rtl:rotate-0 h-[17px] w-[17px] lg:h-[20px] lg:w-[20px]"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
        >
          <g fill="none">
            <path
              d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z"
            />
            <path
              fill="currentColor"
              d="M3.636 11.293a1 1 0 0 0 0 1.414l5.657 5.657a1 1 0 0 0 1.414-1.414L6.757 13H20a1 1 0 1 0 0-2H6.757l3.95-3.95a1 1 0 0 0-1.414-1.414l-5.657 5.657Z"
            />
          </g>
        </svg>
        <div v-if="isLoadingMoreStores" role="status">
          <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span class="sr-only">Loading...</span>
        </div>
      </span>
      <span class="sr-only">{{ isRightToLeft ? $t('general.previous') : $t('general.next') }}</span>
    </button> -->
  </div>
</template>

<script>
import { lowerString } from "@/helpers";
export default {
  data() {
    return {
      disablePrevArrow: false,
      disableNextArrow: false,
      hideArrows: true,
      isCloseToEnd: false,
      timeoutVal: undefined,
      observer: undefined,
      autoPlayInterval: null,
      shouldLoop: false,
      isMobileView: false,
    };
  },
  props: {
    gap: {
      type: String,
      default: "1",
      required: false
    },
    loop: {
      type: Boolean,
      default: false,
      required: false
    },
    paddingTop: {
      type: String,
      default: "0",
      required: false
    },
    loadMoreStores: {
      type: Function,
      required: false,
      default: ()=>{},
    },
    isLoadingMoreStores: {
      type: Boolean,
      required: false,
      default: false,
    },
    wrapperTagType: {
      type: String,
      default: 'div',
      required: false,
    },
    appendedClass: {
      type: String,
      required: false,
      default: ""
    },
    autoPlaySpeed: {
      type: Number,
      default: 3000,
      required: false
    },
  },
  computed: {
    isRightToLeft() {
      if(!process.client){
        return false;
      }
      return lowerString(this.currentlySelectedLanguage) == "ar";
    }
  },
  watch:{
    isCloseToEnd(newVal,prevVal){
      this.$nextTick(() => {
        const slider = this.$refs?.slider;
        if(!slider){
          return;
        }
        const canBeScrollable = Math.ceil(Math.abs(slider.scrollLeft)) >= (slider.scrollWidth - slider.clientWidth -10);
        if(canBeScrollable && (prevVal!==newVal)&&newVal){
          this.loadMoreStores();
        }
      })

    },
  },
  methods: {
    debounce(callback, timer = 1) {
      if (typeof callback === 'function')
        return (...args) => {
            clearTimeout(this.timeoutVal);
            this.timeoutVal = setTimeout(() => {
              return callback(...args);
            },
            Number(timer)
            );
        };
    },
    scroll(direction) {
      const slider = this.$refs?.slider;
      if(!slider){
        return;
      }
      const scrollAmount = slider.clientWidth / 3;
      
      // If looping and scrolling in the primary direction (right for LTR, left for RTL)
      if (this.loop && ((direction > 0 && !this.isRightToLeft) || (direction < 0 && this.isRightToLeft))) {
        const currentScroll = slider.scrollLeft;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const halfwayPoint = maxScroll / 2;
        
        if (currentScroll >= halfwayPoint) {
          slider.scrollTo({
            left: 0,
            behavior: "auto"
          });
        }
      }
      
      slider.scrollBy({
        left: scrollAmount * direction,
        behavior: "smooth"
      });
    },
    checkScrollPosition() {
      this.$nextTick(() => {
        const slider = this.$refs?.slider;
        if(!slider){
          return;
        }
        this.disablePrevArrow = this.isRightToLeft
          ? slider.scrollLeft >= 0
          : slider.scrollLeft == 0;
        this.disableNextArrow = this.isRightToLeft
          ? Math.abs(slider.scrollLeft) + slider.clientWidth >=
            slider.scrollWidth
          : slider.scrollLeft + slider.clientWidth >= slider.scrollWidth;
          this.isCloseToEnd=Math.ceil(Math.abs(slider.scrollLeft)) >= (slider.scrollWidth - slider.clientWidth -10);
      });
    },
    checkIfContainerIsScrollable(){
      setTimeout(() => {
        const slider = this.$refs?.slider;
        const slotContainer = this.$refs?.slotContainer;
        if(!slider || !slotContainer){
          return;
        }
        
        // Check if slotContainer has children before accessing
        if(!slotContainer.children || slotContainer.children.length === 0){
          return;
        }
        
        // Update mobile view check
        this.isMobileView = window.innerWidth < 768; // Standard mobile breakpoint
        
        // Check if original content width is less than container width
        // Safely access first child with null check
        const firstChild = slotContainer.children[0];
        if(!firstChild){
          return;
        }
        
        const originalContentWidth = firstChild.offsetWidth;
        this.shouldLoop = this.loop && (originalContentWidth < slider.clientWidth);
        
        this.hideArrows = slider.clientWidth == slider.scrollWidth;
        this.checkScrollPosition();
      }, 10);
    },
    onContainerScroll(){
      this.debounce(
            () => {
              this.checkScrollPosition();
            },
            10
          )();
    },
    startAutoPlay() {
      if (this.loop && !this.autoPlayInterval) {
        this.autoPlayInterval = setInterval(() => {
          const slider = this.$refs?.slider;
          if (!slider) return;
          
          const currentScroll = slider.scrollLeft;
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          const halfwayPoint = maxScroll / 2;

          // If we're past the halfway point, jump back to start without animation
          if (currentScroll >= halfwayPoint) {
            slider.scrollTo({
              left: 0,
              behavior: "auto"
            });
          }
          
          // Scroll in opposite direction for RTL
          this.scroll(this.isRightToLeft ? -1 : 1);
        }, this.autoPlaySpeed);
      }
    },
    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }
  },
  mounted() {
    if(process.client){
      // Add resize listener
      window.addEventListener('resize', this.checkIfContainerIsScrollable);
      
      this.$nextTick(() => {
        this.checkIfContainerIsScrollable();
        this.startAutoPlay();
      });

      const slotContainer = this.$refs.slotContainer;

      this.observer = new MutationObserver(() => {
        this.checkIfContainerIsScrollable();
      });

      this.observer.observe(slotContainer, {
        childList: true,
      });
    }
  },
  beforeUnmount(){
    if (this.observer) {
      this.observer.disconnect();
    }
    this.stopAutoPlay();
    // Remove resize listener
    if(process.client) {
      window.removeEventListener('resize', this.checkIfContainerIsScrollable);
    }
  }
};
</script>

<style lang="scss" scoped>
.arrow-shadow {
  filter: drop-shadow(0 0 7px rgba(0, 0, 0, 0.2));
}
.slider-container {
  display: flex;
  position: relative;
  min-height: 50px;
  .arrow__el:not(.loading_more){
    opacity: 1;
    transition: opacity 0.2s linear;
  }
  &:hover{
    .arrow__el{
      opacity: 1;
    }
  }
  .slider {
    transition-duration: .15s;
    transition-timing-function: cubic-bezier(.05,0,0,1);
    overflow-y: hidden;
    overflow-x: auto;
    scroll-behavior: smooth;
  }
}

</style>
